import script from "./ReportIssueDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportIssueDialog.vue?vue&type=script&setup=true&lang=js"

import "./ReportIssueDialog.vue?vue&type=style&index=0&id=1ec5d35a&lang=scss&scoped=true"
import "./ReportIssueDialog.vue?vue&type=style&index=1&id=1ec5d35a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec5d35a"]])

export default __exports__